// extracted by mini-css-extract-plugin
export var btn = "rightSection-module--btn--s9WX+";
export var container = "rightSection-module--container--ixYaw";
export var containerTooltip = "rightSection-module--containerTooltip--w2JNs";
export var notBtn = "rightSection-module--notBtn--t8LIS";